import React from 'react';
import AuthRoute from './AuthRoute';

/**
 * @file AdminRoute.tsx
 * @brief Eine Route, die nur für Benutzer mit der Rolle 'admin' zugänglich ist.
 *
 * Diese Komponente überprüft, ob ein Benutzer angemeldet ist und die Rolle 'admin' besitzt.
 * Wenn der Benutzer nicht angemeldet ist, wird er zur Login-Seite weitergeleitet.
 * Wenn der Benutzer angemeldet ist, aber nicht die Rolle 'admin' hat, wird er zum Kalender weitergeleitet.
 * Andernfalls wird die geschützte Route gerendert.
 *
 * @returns {JSX.Element} Ein React-Element, das entweder zur Login-Seite, zur Kalenderseite
 * oder zur geschützten Route navigiert.
 */
import { Outlet } from 'react-router-dom';

const AdminRoute = () => {
  return <AuthRoute requiredPermission={{ resource: 'admin_access', type: 'can_read' }}><Outlet /></AuthRoute>;
};

export default AdminRoute;
